<template>
    <div class="timeline-container">
        <div class="header">
            <div class="title">最新事件</div>
            <!-- , 有设备加设备就可以了'设备' 黎威更改的BUG不加设备 -->
            <!--dist= ['全部', '越限', '离线', '跳闸','设备'] -->
            <CardTabs :data="dist" 
                :TabsStyle="TabsStyle" 
                @changed="classifyChanged"
                :checked="accidentType">
            </CardTabs>    
        </div>
        <div class="content" v-if="status === 'loading'" v-loading="status === 'loading'">
        </div>
        <div class="content" v-else-if="status === 'error'">
            error
        </div>
        <div class="content" v-else-if="data.length === 0">
            <img :src="require('../../assets/img/not_found_data.png')" alt="">
        </div>
        <div class="content" v-else>
            <TimeLine :timelineData="data" 
                :loadMoreStatus="loadMoreStatus"
                @showDetail="showDetail" 
                @loadMore="loadMore">
            </TimeLine>
        </div>
    </div>
</template>

<script>
import CardTabs from './shared/CardTabs';
import TimeLine from './timeline/TimeLine.vue';

export default {
    props:{
        data: Array,
        accidentType: Number,
        status: String,
        loadMoreStatus: String,
    },
    components: {
        CardTabs,
        TimeLine
    },
    computed:{
dist(){
//     if(this.$store.state.project.currentProject.projectId==3){
//   return ['全部', '跳闸','越限', '离线']
//     }else{
  return ['全部', '紧急', '隐患', '通知']

    // }
  
}
    },
    data () {
        return {
            TabsStyle: {
                // width: '286rem'
            },
        }
    },
    methods: {
        classifyChanged: function (index) {
            // console.log('触发切换', index)
            this.$emit('changed', index)
        },
        showDetail: function (code) {
            this.$emit('showDetail', code);
        },
        loadMore: function () {
            //console.log('加载下一页报警');
            this.$emit('loadMore');
        }
    }
}
</script>

<style lang="less" scoped>
.timeline-container {
    .h(440);
    .w(796);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);
    display: flex;
    flex-direction: column;

    .header {
        display: flex;
        justify-content: space-between;
        padding-left: 24rem;
        padding-right: 24rem;
        height: 64rem;
        line-height: 64rem;

        .title {
            font-size: 18rem;
            font-weight: bold;
            color: #333333;
        }
    }

    .content {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        padding: 24rem 24rem 0 24rem;
        overflow: hidden;
    }
}
</style>